<template>
   <div>
      <div class="card">
         <div class="card-header">
            <h4 v-if="router.currentRoute._value.params.id">Alterar Depoimento</h4>
            <h4 v-else>Criar Depoimento</h4>
         </div>
         <div class="card-body">
            <div class="row">
               <div class="col-md-4">
                  <label for="nome">Nome</label>
                  <input id="nome" type="text" class="form-control" placeholder="Digite um nome:"
                     v-model="state.nome" />
               </div>
               <div class="col-md-4">
                  <label for="status">Status</label>
                  <select v-model="state.status" class="form-select">
                     <option value="ATIVO">Ativo</option>
                     <option value="INATIVO">Inativo</option>
                  </select>
               </div>
               <div class="col-md-4">
                  <label for="nome">Link para Vídeo</label>
                  <input id="nome" type="text" class="form-control" placeholder="Insira um link:"
                     v-model="state.video" />
               </div>
               <div class="col-12">
                  <label for="textto">Texto</label>
                  <textarea id="textto" class="form-control" rows="3" v-model="state.texto"></textarea>
               </div>
            </div>
            <div class="d-flex justify-content-end mt-2">
               <router-link to="/admin/depoimentos">
                  <button type="button" class="btn btn-danger me-1">
                     Cancelar
                  </button>
               </router-link>
               <button type="button" @click="upDepo" class="btn btn-primary"
                  v-if="router.currentRoute._value.params.id">
                  Atualizar
               </button>
               <button type="button" @click="saveDepo" class="btn btn-success" v-else>
                  Salvar
               </button>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
   setup() {

      const storage = useStorage();
      var token = storage.getStorageSync("token");

      const router = useRouter();
      const state = reactive({
         nome: "",
         status: "",
         video: "",
         texto: "",
      });
      onMounted(() => {
         if (router.currentRoute._value.params.id != undefined) {
            fetchDepo();
         }
      });
      async function fetchDepo() {
         try {
            const { data } = await services.depoimentos.getById({
               id: router.currentRoute._value.params.id,
               token
            });
            state.id = data.id;
            state.nome = data.nome;
            state.video = data.video;
            state.status = data.status;
            state.texto = data.texto;
         } catch (error) {
        void error;
      }
      } async function upDepo() {
         let dados = {
            id: state.id,
            nome: state.nome,
            video: state.video,
            texto: state.texto,
            status: state.status,
         };
         try {
            await services.depoimentos.update(dados, token);
            router.push("/admin/depoimentos");
         } catch (error) {
        void error;
      }
      }
      async function saveDepo() {
         let dados = {
            nome: state.nome,
            video: state.video,
            texto: state.texto,
            status: state.status,
         };
         try {
            await services.depoimentos.save(dados, token);
            router.push("/admin/depoimentos");
         } catch (error) {
        void error;
      }
      }
      return {
         upDepo,
         router,
         state,
         saveDepo,
      };
   },
};
</script>

<style scoped>
h4 {
   color: #fff;
}

.card-header {
   background-color: #000;
   color: #fff;
   border-radius: 0px;
}

label {
   color: #000;
   font-size: 12pt;
   margin-bottom: 0;
   margin-top: 5px;
}

input {
   border: solid 1px #000;
}

textarea {
   border: solid 1px #000;
   resize: none;
}

select {
   border: solid 1px #000;
}

.card {
   border: solid 1px #000;
   background-color: #fff;
}

.imagem {
   width: 100%;
   object-fit: cover;
   margin-top: 1em;
   height: auto;
}

.btn_remover {
   border: none;
   outline: none;
   background-color: #ff0000;
   padding: 5px 10px;
   font-size: 12px;
   font-weight: 700;
   color: #fff;
   border-radius: 5px;
   transition: all ease 0.1s;
   box-shadow: 0px 5px 0px 0px #f57171;
}

.btn_remover:active {
   transform: translateY(5px);
   box-shadow: 0px 0px 0px 0px #f57171;
}

.div_btn_x {
   margin-left: 10px;
   margin-top: 20px;
}
</style>